import React, { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useMemo } from "react"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import { Table, Row, Col, Card, CardBody } from "reactstrap"

// assets
import "../../../../assets/css/Sales/Sales.css"
import "../../../../assets/css/Sales/Contract.css"
import assign from "../../../../assets/images/users/avatar-1.jpg"

// common component
import Pagination from "components/Common/Pagination"
import ProfileDetails from "components/Common/ProfileDetails"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import moment from "moment"
import configure from "configure"

// components

function TableContainer({ columns, data }) {
  const [fixedContent, setFixedContent] = useState(false)

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])

  // Render the UI for your table
  return (
    <div>
      <div
        className={`flex-column fixed-buttons pt-2 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col md={3}>
          <select
            className=" me-4 form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 25, 50, 100].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={9} className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="text-md-end">
            <button
              onClick={() => navigate(-1)}
              className=" btn btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${fixedContent ? "fixed-header" : ""} contract-colums`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`proj-t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <i
                        title="info"
                        className="bx bx-info-circle ms-1 info-icon"
                      ></i>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="contract-colums" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        onClick={() =>
                          cell.column.Header === "Company"
                            ? navigate(`${configure.appUrl}sales/edit-contract`)
                            : ""
                        }
                        className={`t-col-${index + 1} ${
                          cell.column.className
                        } ${
                          cell.column.Header === "Signature"
                            ? cell.value === "Not-Signed"
                              ? "text-danger"
                              : "text-success"
                            : ""
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
            {data.length == 0 ? (
              <td
                colSpan="10"
                className="text-center"
                style={{ padding: "10px", border: "none" }}
              >
                No Project Available for this Customer
              </td>
            ) : null}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const Project = ({ verticalActiveTab }) => {
  //meta title
  document.title = "Contract | Zithas Crm"

  useEffect(() => {
    if (verticalActiveTab == "6") {
      fetchPropsal()
    }
  }, [verticalActiveTab])

  const params = useParams()
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])

  const fetchPropsal = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("customer_id", params.id)
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/show_customer_project`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(response => {
        setData(response.data.data)
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center",
      },
      {
        Header: "Project Name",
        accessor: "project_name",
        isInfoIcon: true,
      },
      {
        Header: "Customer",
        accessor: "customer_name",
        isInfoIcon: true,
        className: "cursor-pointer",
      },
      {
        Header: "Start Date",
        accessor: "startdate",
        isInfoIcon: true,
        Cell: cellProps => {
          return (
            <div>
              {moment(cellProps.row.original.startdate.slice(0, 10)).format(
                "DD-MM-YYYY"
              )}
            </div>
          )
        },
      },
      {
        Header: "Due Date",
        accessor: "deliverydatebefore",
        isInfoIcon: true,
        className: "text-center",
        Cell: cellProps => {
          return (
            <div>
              {moment(
                cellProps.row.original.deliverydatebefore.slice(0, 10)
              ).format("DD-MM-YYYY")}
            </div>
          )
        },
      },
      {
        Header: "P.W.D",
        accessor: "pending_days",
        isInfoIcon: true,
      },
      {
        Header: "Days",
        accessor: "days",
        isInfoIcon: true,
      },
      {
        Header: "Status",
        accessor: "status",
        isInfoIcon: true,
        Cell: cellProps => {
          let status
          if (cellProps.row.original.status == "In Progress") {
            status = (
              <span className="bg-info badge">
                {cellProps.row.original.status}
              </span>
            )
          } else if (cellProps.row.original.status == "On Hold") {
            status = (
              <span className="bg-warning badge">
                {cellProps.row.original.status}
              </span>
            )
          } else if (cellProps.row.original.status == "Cancelled") {
            status = (
              <span className="bg-danger badge">
                {cellProps.row.original.status}
              </span>
            )
          } else {
            status = (
              <span className="bg-secondary badge">
                {cellProps.row.original.status}
              </span>
            )
          }

          return <div>{status}</div>
        },
      },
      {
        Header: "D.I.D",
        accessor: "signature",
        isInfoIcon: true,
        Cell: cellProps => {
          const current = new Date()
          const delivery = new Date(cellProps.row.original.deliverydatebefore)
          const Difference_In_Days =
            (current.getTime() - delivery.getTime()) / (1000 * 3600 * 24)

          return <div>{parseInt(Difference_In_Days)}</div>
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: cellProps => {
          return (
            <div>
              <a
                className="btn btn-sm btn-outline-secondary me-1"
                title="View Proposal"
              >
                <i className="fas fa-eye "></i>
              </a>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Row className="mx-1">
        <Col lg={12} className="p-0">
          <Card>
            <CardBody>
              <div className="responsive-table">
                <TableContainer columns={columns} data={data} />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Project
